module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1",
    attrs: {
      "id": "copyright"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Copyright © 2014 by Tyler Cohen Wood")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATCHING THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATFISHERS")]), _c('br'), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITED BY")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRSTEN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLEY")]), _c('br'), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPESET BY")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INA")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHENCK")]), _c('br'), _vm._v("Cover design by Rob Johnson"), _c('br'), _vm._v("Printed in the U.S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further information on books from Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "pub1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub1.jpg"
    }
  })])]), _c('p', {
    staticClass: "copyrighta"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The Career Press, Inc."), _c('br'), _vm._v("220 West Parkway, Unit 12"), _c('br'), _vm._v("Pompton Plains, NJ 07444"), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.careerpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.careerpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightaa"
  }, [_vm._v("Wood, Tyler Cohen, 1973-"), _c('br'), _vm._v("   Catching the catfishers : disarm the online pretenders, predators, and perpetrators who are out to ruin your life / by Tyler Cohen Wood. -- 1 Edition."), _c('br'), _vm._v("        pages cm"), _c('br'), _vm._v("   Includes bibliographical references and index."), _c('br'), _vm._v("   ISBN 978-1-60163-307-1 -- ISBN 978-1-60163-485-6 (ebook) 1."), _c('br'), _vm._v("Online identity theft. 2. Online identity theft--Prevention. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("HV6675.W66 2014"), _c('br'), _vm._v("613.60285’4678--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightc"
  }, [_vm._v("2013045967")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0